import { defineStore } from 'pinia';
import api from "@/api/axios";

export const useListadosEntidadesStore = defineStore('listadosEntidades', {
    state: () => ({
        industrias: [],
        martilleros: [],
        modalidadesSubastas: [],
        paises: [],
        provincias: [],
        terminosCondiciones: [],
        tipificados: [],
        tiposArchivos: [],
        tiposCreditos: [],
        historialOfertas: [],
        categorias: [],
        categoriasTipificados: []
    }),
    actions: {
        getCategorias(params = {}) {
            return api
                .get(`/categorias`, { params })
                .then((response) => { this.categorias = response.data });
        },
        getCategoriasTipificados(subasta_id, params = {}) {
            return api
                .get(`/categorias/tipificados/${subasta_id}`, { params })
                .then((response) => { this.categoriasTipificados = response.data });
        },
        getIndustrias(params = {}) {
            return api
                .get(`/industrias`, { params })
                .then((response) => { this.industrias = response.data });
        },

        getProvincias(params = {}) {
            return api
                .get(`/provincias`, { params })
                .then((response) => { this.provincias = response.data });
        },
        getHistorialOfertas(params = {}) {
            return api
                .get("/pujas/mis-ofertas", { params })
                .then((response) => { this.historialOfertas = response.data });
        }
    },
    getters: {

    },
});